/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type PERIODICITY = "DAILY" | "MONTHLY" | "WEEKLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_HOURS" | "FIXED_PRICE" | "TIME_AND_MATERIALS" | "%future added value";
export type DeleteRetainerPeriodBulkInput = {
    ids?: Array<string | null> | null | undefined;
    projectId?: string | null | undefined;
    keepRollovers?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteRetainerPeriodBulkMutationVariables = {
    input: DeleteRetainerPeriodBulkInput;
};
export type deleteRetainerPeriodBulkMutationResponse = {
    readonly deleteRetainerPeriodBulk: {
        readonly project: {
            readonly retainerPeriods: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly name: string | null;
                        readonly startYear: number | null;
                        readonly startMonth: number | null;
                        readonly startDay: number | null;
                        readonly endYear: number | null;
                        readonly endMonth: number | null;
                        readonly endDay: number | null;
                        readonly available: number | null;
                        readonly periodLength: number | null;
                        readonly periodPeriodicity: PERIODICITY | null;
                        readonly periodPriceAmount: number | null;
                        readonly periodHoursAmount: number | null;
                        readonly periodBudgetType: PERIOD_BUDGET_TYPE | null;
                        readonly periodSettingIgnoreForBilling: boolean | null;
                        readonly periodSettingSubtractValue: boolean | null;
                        readonly periodSettingRollValue: boolean | null;
                        readonly periodSettingAddExpenses: boolean | null;
                        readonly periodDifferencePriceAmount: number | null;
                        readonly periodDifferenceHoursAmount: number | null;
                        readonly sharedPeriodDifferenceHoursAmount: number | null;
                        readonly sharedPeriodDifferencePriceAmount: number | null;
                        readonly ignoredRolloverHours: number | null;
                        readonly ignoredRolloverPrice: number | null;
                        readonly periodLocked: boolean | null;
                        readonly periodLockedTime: string | null;
                        readonly periodDifferenceSplit: boolean | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type deleteRetainerPeriodBulkMutation = {
    readonly response: deleteRetainerPeriodBulkMutationResponse;
    readonly variables: deleteRetainerPeriodBulkMutationVariables;
};



/*
mutation deleteRetainerPeriodBulkMutation(
  $input: DeleteRetainerPeriodBulkInput!
) {
  deleteRetainerPeriodBulk(input: $input) {
    project {
      retainerPeriods(first: 100000) {
        edges {
          node {
            id
            name
            startYear
            startMonth
            startDay
            endYear
            endMonth
            endDay
            available
            periodLength
            periodPeriodicity
            periodPriceAmount
            periodHoursAmount
            periodBudgetType
            periodSettingIgnoreForBilling
            periodSettingSubtractValue
            periodSettingRollValue
            periodSettingAddExpenses
            periodDifferencePriceAmount
            periodDifferenceHoursAmount
            sharedPeriodDifferenceHoursAmount
            sharedPeriodDifferencePriceAmount
            ignoredRolloverHours
            ignoredRolloverPrice
            periodLocked
            periodLockedTime
            periodDifferenceSplit
          }
        }
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteRetainerPeriodBulkInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100000
    }
  ],
  "concreteType": "RetainerPeriodTypeConnection",
  "kind": "LinkedField",
  "name": "retainerPeriods",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetainerPeriodTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RetainerPeriodType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "available",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodLength",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodPeriodicity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodPriceAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodHoursAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodBudgetType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodSettingIgnoreForBilling",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodSettingSubtractValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodSettingRollValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodSettingAddExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodDifferencePriceAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodDifferenceHoursAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sharedPeriodDifferenceHoursAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sharedPeriodDifferencePriceAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ignoredRolloverHours",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ignoredRolloverPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodLocked",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodLockedTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodDifferenceSplit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "retainerPeriods(first:100000)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteRetainerPeriodBulkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteRetainerPeriodBulkPayload",
        "kind": "LinkedField",
        "name": "deleteRetainerPeriodBulk",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteRetainerPeriodBulkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteRetainerPeriodBulkPayload",
        "kind": "LinkedField",
        "name": "deleteRetainerPeriodBulk",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteRetainerPeriodBulkMutation",
    "operationKind": "mutation",
    "text": "mutation deleteRetainerPeriodBulkMutation(\n  $input: DeleteRetainerPeriodBulkInput!\n) {\n  deleteRetainerPeriodBulk(input: $input) {\n    project {\n      retainerPeriods(first: 100000) {\n        edges {\n          node {\n            id\n            name\n            startYear\n            startMonth\n            startDay\n            endYear\n            endMonth\n            endDay\n            available\n            periodLength\n            periodPeriodicity\n            periodPriceAmount\n            periodHoursAmount\n            periodBudgetType\n            periodSettingIgnoreForBilling\n            periodSettingSubtractValue\n            periodSettingRollValue\n            periodSettingAddExpenses\n            periodDifferencePriceAmount\n            periodDifferenceHoursAmount\n            sharedPeriodDifferenceHoursAmount\n            sharedPeriodDifferencePriceAmount\n            ignoredRolloverHours\n            ignoredRolloverPrice\n            periodLocked\n            periodLockedTime\n            periodDifferenceSplit\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '47d93fbf4ea5fb2a3d9edd78e1dbeae1';
export default node;
